import axiosInstance from './axiosInstance';

const InsightService = {
    getAll: (severity) => axiosInstance.get('/api/insights', { params: severity ? { severity } : {} }),
    getBriefing: () => axiosInstance.get('/api/insights/briefing'),
    dismiss: (id) => axiosInstance.put(`/api/insights/${id}/dismiss`),
    refresh: () => axiosInstance.post('/api/insights/refresh'),
    revalidate: () => axiosInstance.post('/api/insights/revalidate'),
};

export default InsightService;
